import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalComponent } from "../../../../../shared/components/index";
import { PartNumber } from "../../../../../shared/models/partNumber.model";
import { Log } from "ng2-logger";
import {
    EquipmentFormComponent
} from "../../forms/equipment-form/equipment-form.component";
import { FormType } from "@app/tool/details/components/form-type.enum";
import {Equipment} from "@models/equipment.model";

@Component({
    selector: 'app-equipment-form-modal',
    templateUrl: './equipment-form-modal.component.html',
    styleUrls: ['./equipment-form-modal.component.scss']
})
export class EquipmentFormModalComponent {
    _logger = Log.create(EquipmentFormModalComponent.name);

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    @ViewChild(EquipmentFormComponent, {static: true}) equipmentForm: EquipmentFormComponent;

    @Input() availableEquipment: Equipment[];
    @Input() selectedEquipment: Equipment[];

    @Output() updateEquipment = new EventEmitter<any>();

    showValidations = false;

    constructor() {
    }

    open() {
        this.reset();
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    clickEquipmentUpdate() {
        if (!this.isFormValid()) {
            this._logger.info('clickEquipmentUpdate:: Form is invalid');
            return;
        }

        const selectedEquipment = this.equipmentForm.value();
        this._logger.info('clickEquipmentUpdate:: Selected equipment are', selectedEquipment);

        this.updateEquipment.emit({
            type: FormType.EQUIPMENT,
            equipmentIds: selectedEquipment.equipmentIds
        });
    }

    private reset() {
        this.showValidations = false;
        this.equipmentForm.reset();
        this.modal.close();
    }

    private isFormValid() {
        this.showValidations = true;
        return this.equipmentForm.isFormValid();
    }


}
